<template>
  <el-dialog :title="title" :visible.sync="visible" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="110px">
      <el-form-item label="部门:" prop="deptId">
        <treeselect
          v-model="data.deptId"
          :options="deptOptions"
          @input="deptSelect"
          :defaultExpandLevel="2"
          :show-count="true"
          :clearable="false"
          :disabled="edit"
          placeholder="请选择"
        />
      </el-form-item>
      <el-form-item label="员工:" prop="userId">
        <el-select
          v-model="data.userId"
          :clearable="false"
          filterable
          :disabled="edit"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in userOptions"
            :key="item.userId"
            :label="item.nickName+'（'+item.phonenumber+'）'"
            :value="item.userId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="年份:" prop="targetTime">
        <el-date-picker
          v-model="data.targetTime"
          :disabled="edit"
          value-format="yyyy"
          type="year"
          placeholder="请选择"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="签约目标(元):" prop="signTargetAmount">
        <el-input type="number" v-model="data.signTargetAmount" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="回款目标(元):" prop="fundTargetAmount">
        <el-input type="number" v-model="data.fundTargetAmount" placeholder="请输入" clearable />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {saveKpi} from "@/api/crm/kpi";
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import {mapState} from "vuex";
import {treeSelectWithOutDataScope} from "@/api/system/dept";
import {listUserWithOutDataScope} from "@/api/system/user";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "AddClueDialog",
  props: {},
  data() {
    return {
      title: "",
      edit: false,
      visible: false,
      deptOptions: [],
      userOptions: [],
      rules: {
        signTargetAmount: [
          { required: true, message: "请输入签约目标", trigger: "change" },
          { validator: this.checkNum, trigger: "change" }
        ],
        fundTargetAmount: [
          { required: true, message: "请输入回款目标", trigger: "change" },
          { validator: this.checkNum, trigger: "change" }
        ],
        targetTime: [
          { required: true, message: "请选择年份", trigger: "change" }
        ],
        deptId: [
          {
            required: true,
            message: "请选择部门",
            trigger: "change"
          }
        ],
        userId: [
          {
            required: true,
            message: "请选择员工",
            trigger: "change"
          }
        ]
      },
      data: {
        deptId: null,
        userId: null,
        targetTime: null,
        signTargetAmount: null,
        fundTargetAmount: null
      }
    };
  },
  created() {
    this.getTreeselect();
    this.queryUserList()
  },
  components: {
    UserSelect,
    Treeselect,
    CompanyInput
  },
  watch: {
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      dept: state => state.user.dept,
      userDataScope: state => state.user.userDataScope
    })
  },
  methods: {
    checkNum(rule, value, callback) {
      // 必填
      if (value <= 0) {
        callback(new Error("请输入大于0的数字"));
      } else {
        callback();
      }
    },
    open(item) {
      if (item) {
        this.edit = true;
        this.title = "编辑目标";
        this.data = JSON.parse(JSON.stringify(item));
      } else {
        this.data = {
          id: null,
          deptId: null,
          userId: null,
          targetTime: null,
          signTargetAmount: null,
          fundTargetAmount: null
        }
        if (this.$refs.addForm) {
          this.$refs.addForm.resetFields();
        }
        this.edit = false;
        this.title = "添加目标";
      }
      this.visible = true;
    },
    /** 查询部门下拉树结构 */
    getTreeselect () {
      treeSelectWithOutDataScope().then(response => {
        this.deptOptions = response.data
      });
    },
    queryUserList (deptId) {
      listUserWithOutDataScope({deptId: deptId}).then(response2 => {
        this.userOptions = response2.rows;
      });
    },
    deptSelect (value, instanceId) {
      this.userOptions = []
      if (!this.edit) {
        this.data.userId = null
      }
      listUserWithOutDataScope({deptId: value}).then(response => {
        this.userOptions = response.rows;
      });
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          saveKpi(this.data)
            .then(response => {
              this.visible = false;
              this.$emit("success");
              loading.close();
              this.msgSuccess(this.data.id ? "编辑成功" : "创建成功");
            })
            .catch(error => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
